"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  House3: ['house-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.527,12.463,10.962,3.02a1.5,1.5,0,0,1,2.122.008l9.443,9.435', 'M19.527 9.466L19.527 21.463 4.527 21.463 4.527 9.461', 'M15.027,21.463v-4.5a3,3,0,1,0-6,0v4.5', 'M10.152 9.088 A1.875 1.875 0 1 0 13.902 9.088 A1.875 1.875 0 1 0 10.152 9.088 Z']],
  House: ['house', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.272,23.247a.981.981,0,0,0,.978-.978V9.747a1.181,1.181,0,0,0-.377-.8L12,.747,1.127,8.947a1.181,1.181,0,0,0-.377.8V22.269a.981.981,0,0,0,.978.978Z']],
  House1: ['house-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.753,13.944v8.25h6v-6a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5v6h6v-8.25', 'M.753,12.444,10.942,2.255a1.5,1.5,0,0,1,2.122,0L23.253,12.444']],
  HouseChimney1: ['house-chimney-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.873,8.947,20.25,6.969V1.5H16.5V4.141L12,.748,1.127,8.947a1.184,1.184,0,0,0-.377.8V22.269a.981.981,0,0,0,.978.979H8.25v-7.5a1.5,1.5,0,0,1,1.5-1.5h4.5a1.5,1.5,0,0,1,1.5,1.5v7.5h6.522a.981.981,0,0,0,.978-.979V9.748A1.184,1.184,0,0,0,22.873,8.947Z']],
  HouseEntrance: ['house-entrance', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.868,8.947,12,.747,1.122,8.947a1.177,1.177,0,0,0-.377.8V22.269a.981.981,0,0,0,.978.978H8.245V18a3.75,3.75,0,0,1,7.5,0v5.25h6.521a.982.982,0,0,0,.979-.978V9.747A1.181,1.181,0,0,0,22.868,8.947Z']],
  House4: ['house-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5 9.744L12 0.744 22.5 9.744', 'M12,5.244,3.377,12.61a1.186,1.186,0,0,0-.377.8v8.855a.981.981,0,0,0,.978.978H9.75v-7.01a.491.491,0,0,1,.489-.49h3.522a.491.491,0,0,1,.489.49v7.01h5.772A.981.981,0,0,0,21,22.266V13.411a1.186,1.186,0,0,0-.377-.8Z']],
  HouseChimney2: ['house-chimney-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.754,13.923v8.25h6v-6a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5v6h6v-8.25', 'M.754,12.423,10.944,2.234a1.5,1.5,0,0,1,2.121,0L23.254,12.423', 'M16.504 5.673L16.504 4.173 20.254 4.173 20.254 9.423']],
  HouseChimney: ['house-chimney', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.871,8.947,20.248,6.969V1.5H16.5V4.141L12,.748,1.125,8.947a1.184,1.184,0,0,0-.377.8V22.269a.981.981,0,0,0,.978.979H22.27a.981.981,0,0,0,.978-.979V9.748A1.184,1.184,0,0,0,22.871,8.947Z']],
  BirdHouse: ['bird-house', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.96,9,6.34,22.288A1.226,1.226,0,0,0,7.5,23.25h9a1.225,1.225,0,0,0,1.156-.962L21.033,9', 'M0.747 11.021L11.997 0.75 23.247 11.021', 'M8.997 14.250 A3.000 3.000 0 1 0 14.997 14.250 A3.000 3.000 0 1 0 8.997 14.250 Z']],
  House2: ['house-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.458,12.171l9.435-9.443a1.5,1.5,0,0,1,2.122.007l9.443,9.436', 'M19.458 9.173L19.458 21.171 4.458 21.171 4.458 9.168', 'M14.958,21.171v-4.5a3,3,0,0,0-6,0v4.5']]
};
exports["default"] = _default;